import { render, staticRenderFns } from "./OrderGroupMaterial.vue?vue&type=template&id=8f03b56a&scoped=true&"
import script from "./OrderGroupMaterial.vue?vue&type=script&lang=js&"
export * from "./OrderGroupMaterial.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupMaterial.vue?vue&type=style&index=0&id=8f03b56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f03b56a",
  null
  
)

export default component.exports